import React, { PropsWithChildren, useMemo } from "react"

import { useHttp } from "@cirrus/core/http/provider"
import { IHttpResponse } from "@cirrus/core/http/types"
import { ANGOFF_SETTINGS_DEFAULT } from "@cirrus-author/library/constants"

import { useFrontendConfig } from "../../FrontendConfig"
import { CustomerInfoProvider } from "../context"
import { CustomerInfo } from "../types/CustomerInfo"
import { CustomerInfoService } from "../types/CustomerInfoService"

export const BasicCustomerInfoProvider = ({ children }: PropsWithChildren) => {
	const { Customer } = useFrontendConfig()
	const { http } = useHttp()

	const service: CustomerInfoService = useMemo(() => ({
		getCustomerInfo: () => http.get<IHttpResponse<CustomerInfo>>(`/api/v1/customer/${Customer}/info`, {
			validateStatus: (status) => {
				// if (status === 404) window.location.assign("/site-entry")
				// if (status === 500) window.location.assign("/500")

				return status >= 200 && status < 300;
			},
			transformResponse: (data) => {
				try {
					if (!data) return null

					const parsedData = JSON.parse(data)

					return {
						...parsedData,
						angoff: parsedData.angoff ?? ANGOFF_SETTINGS_DEFAULT
					}
				} catch (error) {
					console.warn(error)
					return null
				}
			}
		})
	}), [Customer])

	return <CustomerInfoProvider service={service}>{children}</CustomerInfoProvider>
}
